// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m6-0";
export var fileList = "_m6-2";
export var removeFileButton = "_m6-1";